import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = ({ onClick, label = 'Geri', ...props }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Button
      onClick={handleClick}
      startIcon={<ArrowBackIcon sx={{ width: 15 }} />}
      size="small"
      sx={{
        textTransform: 'none',
        // backgroundColor: '#E7EDF4',
        backgroundColor: 'transparent',
        border: '1px solid #CFDBEA',
        boxShadow: 'none',
        fontSize: 13,
        borderRadius: '5px',
        px: 2,
        color: '#0E4D94',
        width: 'fit-content',
        alignSelf: 'flex-start',
        '&:hover': {
          backgroundColor: '#CFDBEA',
          boxShadow: 'none',
        },
        ...props.sx,
      }}
      {...props}
    >
      {label}
    </Button>
  );
};

export default BackButton;
